import { z } from "zod";

// goals.config の中身。source列挙値と1:1対応するdiscriminated union
export const ga4EventGoalConfigSchema = z.object({
  source: z.literal("ga4_event"),
  ga4EventName: z.string().min(1),
});

export const selectorGoalConfigSchema = z.object({
  source: z.literal("selector"),
  selector: z.string().min(1),
  event: z.literal("click"),
});

export const urlGoalConfigSchema = z.object({
  source: z.literal("url"),
  url: z.string().min(1),
  matchType: z.enum(["exact", "prefix", "regex"]),
});

export const customGoalConfigSchema = z.object({
  source: z.literal("custom"),
  goalKey: z.string().min(1),
});

export const goalConfigSchema = z.discriminatedUnion("source", [
  ga4EventGoalConfigSchema,
  selectorGoalConfigSchema,
  urlGoalConfigSchema,
  customGoalConfigSchema,
]);

export type GoalConfig = z.infer<typeof goalConfigSchema>;
